import config from '@config';

export function getEventUrl(event, organizer) {
  let eventUrl = event.title
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/\u0142/g, 'l')
    .replace(/\s/g, '-')
    .replace(/[^-A-Z0-9 ]+/gi, '');
  const link2 = eventUrl.replace(/([-])\1+/gi, '-').replace(/[=<>*\^\[\]\"\']+/g, '');

  if (eventUrl !== link2) {
    eventUrl = link2;
  }

  const url = `/${event.organizer_link || organizer.link}/${eventUrl}_${createEventID(event.id)}/`;

  return url;
}
export function checkAndGetEventID(uriParam){
  let event_id = parseInt(uriParam.split('_')[1],36);
  const checNum = event_id % 10;
  event_id = Math.floor(event_id / 10 ^ 0);
  return (checksum(String(event_id))!==checNum) ? null : event_id
}
export function createEventID(eID) {
  const withChecksum = parseInt(String(eID) + String(checksum(String(eID))));

  return withChecksum.toString(36)
}

export function formatDateRange(startDate, endDate) {
  const start = dayjs(dayjs.utc(startDate).format());
  const end = dayjs(dayjs.utc(endDate).format());
  const tmp = new Date(start);
  let localTimezone = (tmp.getTimezoneOffset() / 60) * -1;

  if (localTimezone > -1) {
    localTimezone = `+${localTimezone}`;
  }

  const td1 = start.format('DD-MM');
  const td2 = end.format('DD-MM');

  let eventTermin = '';

  if (td1 === td2) {
    eventTermin = start.format('H:mm');
    eventTermin += ` - ${end.format('H:mm, DD MMMM')}`;
  } else {
    eventTermin = start.format('H:mm, DD MMMM');
    eventTermin += ` - ${end.format('H:mm, DD MMMM')}`;
  }

  eventTermin += ` (GMT${localTimezone})`;

  return eventTermin;
}

export function getUTCDateRange(startDate, endDate) {
  const start = getUTCDate(startDate);
  const end = getUTCDate(endDate);

  return [start, end];
}

export function getUTCDate(date) {
  return dayjs(dayjs.utc(date).format());
}

export function scrollToElement(target) {
  if (typeof target === 'string') {
    document.querySelector(target).scrollIntoView({ behavior: 'smooth' });
  } else {
    target.scrollIntoView({ behavior: 'smooth' });
  }
}

export function debounce(callback, delay) {
  let timeout;

  return () => {
    clearTimeout(timeout);

    timeout = setTimeout(callback, delay);
  }
}

export function queryToObject(query) {
  const entries = query.entries();
  const result = {};

  for (const [key, value] of entries) {
    result[key] = value;
  }

  return result;
}
